<div *ngIf="producto" class="formgrid grid">
    <div class="field col-4">
        <label for="factura">Factura</label>
        <input id="factura" type="text" [value]="producto.factura.numero_factura" readonly
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
    </div>
    <div class="field col-4">
        <label for="nomproducto">Nombre Producto</label>
        <input id="nomproducto" type="text" [value]="producto.tipo_producto.descripcion" readonly
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
    </div>
    <div class="field col-4">
        <label for="lote">Lote</label>
        <input id="lote" type="text" [value]="producto.lote" readonly
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
    </div>
    <div class="field col-4">
        <label for="cantidad">Cantidad productos facturados</label>
        <input id="cantidad" type="text" [value]="producto.cantidad_productos" readonly
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
    </div>
    <div class="field col-4">
        <label for="registrados">Registrados</label>
        <input id="registrados" type="text" [value]="producto.trazabilidad_productos.length" readonly
            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full">
    </div>
</div>
<!-- Botones de acción -->
<div class="flex justify-content-end gap-3">

    <p-button label="Salir" type="button" icon="pi pi-sign-out" styleClass="p-button-secondary"
        (click)="salir()"></p-button>

    <p-button (click)="showDialog()" icon="pi pi-external-link" label="Registrar"></p-button>
</div>

<p-divider></p-divider>
<div *ngIf="producto">
    <p-table [value]="producto.trazabilidad_productos" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="6" class="text-2xl" style="text-align: center;">Trazabilidad de productos</th>
            </tr>
            <tr>
                <th>#</th>
                <th>Producto</th>
                <th>Lote</th>
                <th>Hospital</th>
                <th>Paciente</th>
                <th>Medico</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product let-index="rowIndex">
            <tr>
                <td style="width: 5%; text-align: center;">{{index +1 }}</td>
                <td>{{ product.tipo_producto?.descripcion }}</td>
                <td>{{ product.lote }}</td>
                <td>{{ product.nom_hospital }}</td>
                <td>{{ product.nom_paciente }}</td>
                <td>{{ product.nom_medico }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">Sin registro de productos con su trazabilidad</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>


<p-dialog header="Registro de Producto" [(visible)]="visible" [style]="{width: '50vw'}" [maximizable]="true">
    <ng-template pTemplate="header">
        <span class="text-4xl font-bold">Registro de Producto</span>
    </ng-template>
    <div *ngIf="productoForm">
        <form id="productoFrm" [formGroup]="productoForm" (ngSubmit)="onSubmit()">
            <div class="formgrid grid">
                <!--
            <div class="field">
                <label for="factura">Factura:*</label>
                <select id="factura" formControlName="fk_factura"
                    [ngClass]="{'ng-invalid ng-dirty': getControl('fk_factura').touched && getControl('fk_factura').invalid}">
                    <option value="" disabled selected>Seleccione una factura</option>
                    <option *ngFor="let factura of facturas" [value]="factura.id">{{ factura.factura }}</option>
                </select>
        
                <small class="error" *ngIf="getControl('fk_factura').touched && getControl('fk_factura').invalid">
                    <span *ngIf="getControl('fk_factura')?.hasError('required')">
                        Campo obligatorio
                    </span>
                </small>
            </div> 
            -->



                <!-- NOMBRE DEL PRODUCTO -->
                <!-- 
                
             <div class="field">
                 <label for="nom_producto">Nombre del producto:*</label>
                 <input id="nom_producto" name="nom_producto" type="text" formControlName="nom_producto"
                     [ngClass]="{'ng-invalid ng-dirty':getControl('nom_producto').touched && getControl('nom_producto').invalid}" />
                 <small class="error" *ngIf="getControl('nom_producto').touched && getControl('nom_producto').invalid">
                     <span *ngIf="getControl('nom_producto')?.hasError('required')">
                         Campo obligatorio
                     </span>
                     <span *ngIf="getControl('nom_producto')?.hasError('maxlength')">
                         Máximo {{getControl('nom_producto').getError('maxlength').requiredLength }} caracteres
                     </span>
                     <span *ngIf="getControl('nom_producto').hasError('pattern')">
                         Formato inválido
                     </span>
                     <span *ngIf="getControl('nom_producto').hasError('email')">
                         Correo inválido
                     </span>
                 </small>
             </div>
            
            -->

                <!-- LOTE -->
                <div class="field col-4">
                    <label for="lote">Lote:*</label>
                    <input id="lote" name="lote" pInputText type="text" formControlName="lote"
                        class="p-inputtext-md w-full"
                        [ngClass]="{'ng-invalid ng-dirty':getControl('lote').touched && getControl('lote').invalid}" />
                    <small class="error" *ngIf="getControl('lote').touched && getControl('lote').invalid">
                        <span *ngIf="getControl('lote').hasError('required')">
                            Campo obligatorio
                        </span>
                        <span *ngIf="getControl('lote').hasError('maxlength')">
                            Máximo {{getControl('lote').getError('maxlength').requiredLength }} caracteres
                        </span>
                        <span *ngIf="getControl('lote').hasError('pattern')">
                            Formato inválido
                        </span>
                    </small>
                </div>

                <!-- FECHA DE APLICACION DEL PRODUCTO-->
                <div class="field col-4">
                    <label for="fecha">Fecha de aplicación del producto:*</label>
                    <input id="fecha" name="fecha" type="date" pInputText formControlName="fecha_aplicacion_producto"
                        class="p-inputtext-md w-full"
                        [ngClass]="{'ng-invalid ng-dirty':getControl('fecha_aplicacion_producto').touched && getControl('fecha_aplicacion_producto').invalid}" />
                    <small class="error"
                        *ngIf="getControl('fecha_aplicacion_producto').touched && getControl('fecha_aplicacion_producto').invalid">
                        <span *ngIf="getControl('fecha_aplicacion_producto').hasError('fecha_aplicacion_producto')">
                            Campo obligatorio
                        </span>
                    </small>
                </div>

                <!-- NOMBRE DE HOSPITAL -->
                <div class="field col-4">
                    <label for="hospital">Nombre del Hospital:*</label>
                    <input id="hospital" name="hospital" pInputText type="text" formControlName="nom_hospital"
                        class="p-inputtext-md w-full"
                        [ngClass]="{'ng-invalid ng-dirty':getControl('nom_hospital').touched && getControl('nom_hospital').invalid}" />
                    <small class="error"
                        *ngIf="getControl('nom_hospital').touched && getControl('nom_hospital').invalid">
                        <span *ngIf="getControl('nom_hospital').hasError('required')">
                            Campo obligatorio
                        </span>
                        <span *ngIf="getControl('nom_hospital').hasError('maxlength')">
                            Máximo {{getControl('nom_hospital').getError('maxlength').requiredLength }} caracteres
                        </span>
                    </small>
                </div>

                <!-- NOMBRE DE MEDICO -->
                <div class="field col-4">
                    <label for="medico">Nombre del Medico:</label>
                    <input id="medico" name="medico" type="text" pInputText formControlName="nom_medico"
                        class="p-inputtext-md w-full"
                        [ngClass]="{'ng-invalid ng-dirty':getControl('nom_medico').touched && getControl('nom_medico').invalid}" />
                    <small class="error" *ngIf="getControl('nom_medico').touched && getControl('nom_medico').invalid">
                        <span *ngIf="getControl('nom_medico').hasError('required')">
                            Campo obligatorio
                        </span>
                        <span *ngIf="getControl('nom_medico').hasError('maxlength')">
                            Máximo {{getControl('nom_medico').getError('maxlength').requiredLength }} caracteres
                        </span>
                        <span *ngIf="getControl('nom_medico').hasError('pattern')">
                            Formato inválido
                        </span>
                    </small>
                </div>
                <!-- NOMBRE DE PACIENTE -->
                <div class="field col-4">
                    <label for="paciente">Nombre del Paciente:</label>
                    <input id="paciente" name="paciente" pInputText type="text" formControlName="nom_paciente"
                        class="p-inputtext-md w-full"
                        [ngClass]="{'ng-invalid ng-dirty':getControl('nom_paciente').touched && getControl('nom_paciente').invalid}" />
                    <small class="error"
                        *ngIf="getControl('nom_paciente').touched && getControl('nom_paciente').invalid">
                        <span *ngIf="getControl('nom_paciente').hasError('required')">
                            Campo obligatorio
                        </span>
                        <span *ngIf="getControl('nom_paciente').hasError('maxlength')">
                            Máximo {{getControl('nom_paciente').getError('maxlength').requiredLength }} caracteres
                        </span>
                        <span *ngIf="getControl('nom_paciente').hasError('pattern')">
                            Formato inválido
                        </span>
                    </small>
                </div>
                <!-- ESTADO -->
                <div class="field col-4">
                    <label for="estado">Estado:*</label>
                    <input id="estado" name="paciente" pInputText type="text" formControlName="entidad_federativa"
                        class="p-inputtext-md w-full"
                        [ngClass]="{'ng-invalid ng-dirty':getControl('entidad_federativa').touched && getControl('entidad_federativa').invalid}" />
                    <small class="error"
                        *ngIf="getControl('entidad_federativa').touched && getControl('entidad_federativa').invalid">
                        <span *ngIf="getControl('entidad_federativa').hasError('required')">
                            Campo obligatorio
                        </span>
                        <span *ngIf="getControl('entidad_federativa').hasError('maxlength')">
                            Máximo {{getControl('entidad_federativa').getError('maxlength').requiredLength }} caracteres
                        </span>
                        <span *ngIf="getControl('entidad_federativa').hasError('pattern')">
                            Formato inválido
                        </span>
                    </small>
                </div>
                <div class="p-field col-12 md-6">
                    <div class="checkbox-container">
                        <p-checkbox formControlName="manifiesto" [binary]="true" inputId="mani">
                        </p-checkbox>
                        <label for="mani">
                            Declaro bajo protesta de decir verdad, que los datos de registro de productos utilizados en
                            los hospitales, con los
                            médicos, y para los pacientes que aquí menciono, son correctos
                        </label>
                    </div>
                </div>

            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <!-- Botones -->
        <div class="buttons">
            <p-button type="button" icon="pi pi-times" label="Cancelar" styleClass="p-button-text p-button-danger"
                (click)="productoForm.reset(); visible = false"></p-button>
            <!--   
                            <button type="button" class="btn btn-secondary" (click)="addCookie()">
                                cookies
                            </button>
                        -->
            <button pButton type="submit" icon="pi pi-save" label="Guardar" form="productoFrm" class="p-button-text"
                [disabled]="productoForm.invalid"></button>
        </div>

    </ng-template>
</p-dialog>
<p-toast></p-toast>